export default __webpack_public_path__ + "static/media/LexwareLogo.c554286f.svg";